export const API = 'http://13.229.66.59:9000/v1/api/';
export const EASY_BUZZ_URL = " https://pay.easebuzz.in/pay";

